const wpEmbedClass = 'cdm-embed-code';

export default wpEmbedClass;
